var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"menubar__button",on:{"click":function($event){return _vm.$emit('openMenu')}}},[_c('font-awesome-icon',{attrs:{"icon":['far', 'bars']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }